import { useTranslation } from 'react-i18next';
import type { FormCheckboxType } from '#pie/components/form/types';
import {
  type CreateDataRequestDto,
  DataType,
  EnergyType,
} from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

const { ConditionalField, FormCheckbox } =
  typedFormFields<CreateDataRequestDto>();

export const EnergyTypes = () => {
  // Assetdata energiesoort
  const { t } = useTranslation('dataRequest');
  const options: FormCheckboxType[] = [
    {
      label: t(`energy_type.${EnergyType.Electricity}`),
      value: EnergyType.Electricity,
    },
    {
      label: t(`energy_type.${EnergyType.Gas}`),
      value: EnergyType.Gas,
    },
  ];

  return (
    <ConditionalField
      field="energyTypes"
      condition={(formValue) => {
        return (
          !!formValue('dataTypes') &&
          formValue('dataTypes')!.includes(DataType.Asset)
        );
      }}
    >
      <FormCheckbox
        label={t('energy_types')}
        name="energyTypes"
        options={options}
        rules={{ required: true }}
      />
    </ConditionalField>
  );
};
